import { render } from "./VehicleDeviationCheckDialog.vue?vue&type=template&id=20e6617b"
import script from "./VehicleDeviationCheckDialog.vue?vue&type=script&lang=ts"
export * from "./VehicleDeviationCheckDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon,QInput,QCardActions,QBtn});
